// eslint-disable-next-line import/prefer-default-export
export const DASHBOARD_SORT_MODEL = 'DASHBOARD_SORT_MODEL';
export const SELSKAP_NR = 'SELSKAP_NR';
export const MOTPART_SELSKAP_NR = 'MOTPART_SELSKAP_NR';
export const HAS_LATEST_EXPORT = 'HAS_LATEST_EXPORT';
export const DASHBOARD_CHOSEN_PERIODE = 'DASHBOARD_CHOSEN_PERIODE';
export const FAVORITT = 'FAVORITT';
export const DASHBOARD_FILTER_MODEL = 'DASHBOARD_FILTER_MODEL';
